import {useTranslation} from '@aboutyou/i18n';
import {Button, COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useHasSimilarProductsRecommendations} from '../../SimilarProducts/hooks/useSimilarProducts';

interface SimilarProductsFabProps {
  onSimilarItemsClick: () => void;
}

export const SimilarProductsFab = (props: SimilarProductsFabProps) => {
  const {onSimilarItemsClick} = props;
  const {t} = useTranslation();
  /**
   * Using this hook here leads to nesting
   * requests which is a big no no. So do not take
   * this as a good example and only do so when
   * there is no way around it.
   */
  const hasRecommendations = useHasSimilarProductsRecommendations();

  if (!hasRecommendations) {
    return null;
  }

  return (
    <FAB
      onClick={onSimilarItemsClick}
      data-testid="scrollToSimilarItems"
      aria-label={undefined}
      rightIcon={
        <Icon
          asset={GenericIconName.ArrowDown}
          size="XXS"
          color={COLORS.Black}
        />
      }
      variant="secondary"
      size="fit-width"
    >
      <span data-testid="scrollToSimilarItemsLabel">
        {t('Similar alternatives')}
      </span>
    </FAB>
  );
};

const FAB = styled(Button)`
  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(10px);
    }
    60% {
      transform: translateY(5px);
    }
  }
  animation: bounce 2s 2;
`;
